import "./insBrowserCompatibility.scss";
import { AuxPageBrowserCompatibility } from "@blk/aladdin-react-components-es";
import React from "react";
import { language } from "language/default";
export const InsBrowserCompatibility = (props) => {
    const { infoAppNotCompatibleWithBrowser, instructionOpenSupportedBrowser, instructionCopyLinkToSupportedBrowser } = language.en.browserCompatibility;
    const { copy } = language.en.common;
    return React.createElement(AuxPageBrowserCompatibility, { applicationUrl: props.applicationUrl, copyButtonLabel: copy, hasLogo: false, hasCustomContent: true },
        React.createElement("div", { slot: "content" },
            React.createElement("div", { className: "banner_header", role: "heading", "aria-level": 1 }, infoAppNotCompatibleWithBrowser),
            React.createElement("div", { className: "banner_text" }, instructionOpenSupportedBrowser),
            React.createElement("div", { className: "banner_note" }, instructionCopyLinkToSupportedBrowser)));
};
